//import { colors } from './../../../config/styles'

export default {
    radio: (disabled) => {}
}